var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayments(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.896%",
    y1: "50%",
    x2: "65.659%",
    y2: "5.648%",
    id: "payments_svg__svg-590351062a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68616",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2A1E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.944 0A2.954 2.954 0 000 2.944v20.98A2.587 2.587 0 002.576 26.5h25.028a2.587 2.587 0 002.577-2.576V6.994a2.587 2.587 0 00-2.577-2.577h-1.84V.737A.765.765 0 0025.028 0H2.944zm0 1.472h21.348v2.945H2.944a1.453 1.453 0 01-1.472-1.473c0-.828.644-1.472 1.472-1.472zM1.472 5.486a2.92 2.92 0 001.472.403c8.29-.007 17.535 0 24.66 0 .624 0 1.104.48 1.104 1.104v4.417H18.035c-1.007 0-1.84.834-1.84 1.84v4.417c0 1.006.833 1.84 1.84 1.84h10.673v4.417c0 .624-.48 1.104-1.104 1.104H2.576c-.624 0-1.104-.48-1.104-1.104V5.486zm16.563 7.396h10.673v5.153H18.035a.352.352 0 01-.368-.368V13.25c0-.217.15-.368.368-.368zm3.68 1.104a1.471 1.471 0 10-.001 2.943 1.471 1.471 0 00.001-2.943z",
    fill: "#00264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.944 0A2.954 2.954 0 000 2.944v20.98A2.587 2.587 0 002.576 26.5h25.028a2.587 2.587 0 002.577-2.576V6.994a2.587 2.587 0 00-2.577-2.577h-1.84V.737A.765.765 0 0025.028 0H2.944zm0 1.472h21.348v2.945H2.944a1.453 1.453 0 01-1.472-1.473c0-.828.644-1.472 1.472-1.472zM1.472 5.486a2.92 2.92 0 001.472.403c8.29-.007 17.535 0 24.66 0 .624 0 1.104.48 1.104 1.104v4.417H18.035c-1.007 0-1.84.834-1.84 1.84v4.417c0 1.006.833 1.84 1.84 1.84h10.673v4.417c0 .624-.48 1.104-1.104 1.104H2.576c-.624 0-1.104-.48-1.104-1.104V5.486zm16.563 7.396h10.673v5.153H18.035a.352.352 0 01-.368-.368V13.25c0-.217.15-.368.368-.368zm3.68 1.104a1.471 1.471 0 10-.001 2.943 1.471 1.471 0 00.001-2.943z",
    fill: "url(#payments_svg__svg-590351062a)",
    opacity: 0
  }))));
}

export default SvgPayments;